var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62035 14.0336L9.62691 14.0382C10.1935 14.399 10.8663 14.5557 11.534 14.4824C12.2017 14.409 12.8244 14.1101 13.2992 13.6349L13.7117 13.2223C13.8031 13.131 13.8756 13.0225 13.9251 12.9031C13.9745 12.7837 14 12.6557 14 12.5265C14 12.3973 13.9745 12.2693 13.9251 12.1499C13.8756 12.0305 13.8031 11.922 13.7117 11.8307L11.9719 10.092C11.8806 10.0006 11.7721 9.92811 11.6527 9.87864C11.5333 9.82916 11.4054 9.80369 11.2762 9.80369C11.1469 9.80369 11.019 9.82916 10.8996 9.87864C10.7802 9.92811 10.6717 10.0006 10.5804 10.092C10.3959 10.2765 10.1458 10.3801 9.88495 10.3801C9.62412 10.3801 9.37397 10.2765 9.18951 10.092L6.40775 7.30935C6.22335 7.12487 6.11975 6.87469 6.11975 6.61383C6.11975 6.35298 6.22335 6.1028 6.40775 5.91832V5.91832C6.49916 5.82697 6.57167 5.71849 6.62114 5.59909C6.67062 5.4797 6.69608 5.35172 6.69608 5.22248C6.69608 5.09324 6.67062 4.96527 6.62114 4.84587C6.57167 4.72648 6.49916 4.618 6.40775 4.52664L4.66866 2.78803C4.4842 2.6036 4.23405 2.5 3.97322 2.5C3.71239 2.5 3.46224 2.6036 3.27778 2.78803L2.86465 3.20055C2.38961 3.67549 2.09079 4.2983 2.01758 4.96607C1.94437 5.63385 2.10115 6.30662 2.46201 6.87322L2.46594 6.87978C4.37172 9.69972 6.80035 12.1282 9.62035 14.0336V14.0336Z",
    stroke: "#6AA8EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedPhone);
export default __webpack_public_path__ + "static/media/OutlinedPhone.a6cf9085fbe4753cbf342ce170de9f97.svg";
export { ForwardRef as ReactComponent };